import React from "react";
import { motion } from "framer-motion";

const Header = ({ loading }) => {
  const variants = {
    initial: { width: "100%" },
    animate: {
      width: "0%",
      transition: {
        duration: 1.5,
        delay: 0.9,
      },
    },
  };
  return (
    <div id="top" className="pt-5 padding bg-bg1  relative">
      <motion.div
        variants={variants}
        initial="initial"
        animate={loading ? "initial" : "animate"}
        className="bg-bg1 w-screen h-32 absolute top-0"
      ></motion.div>
      <div className="flex justify-between text-text1 font-advent text-xl tracking-widest py-1  ">
        <div className="">Jan Durcak</div>
        <div>Portfolio</div>
        <div className="hidden sm:block">2021</div>
      </div>
      <div className="border border-text1"></div>
    </div>
  );
};

export default Header;
